import React, { useState } from "react";
import { Tabs } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileAlt as faFileAltDuotone,
  faClock as faClockDuotone,
  faSearch as faSearchDuotone,
  faBoxOpen as faBoxOpenDuotone,
  faShip as faShipDuotone,
  faCheckCircle as faCheckCircleDuotone,
} from "@fortawesome/pro-duotone-svg-icons";
import PurchaseOrderTableComponent from "../components/PurchaseOrderTableComponent";

const statusTabs = [
  { key: "SUB", label: "Submitted", icon: faFileAltDuotone },
  { key: "AWC", label: "Awaiting Confirmation", icon: faClockDuotone },
  { key: "AQA", label: "Awaiting QA", icon: faSearchDuotone },
  { key: "PSH", label: "Pending Shipment", icon: faBoxOpenDuotone },
  { key: "SHC", label: "Shipment Confirmed", icon: faShipDuotone },
  { key: "FSH", label: "Fully Shipped", icon: faCheckCircleDuotone },
];

const PurchaseOrderGateway = () => {
  const [activeTab, setActiveTab] = useState(statusTabs[0].key);

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg">
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="card"
        tabBarGutter={0}
        className="custom-tabs"
        tabBarStyle={{ padding: 0, margin: 0 }}
      >
        {statusTabs.map((tab) => (
          <Tabs.TabPane
            key={tab.key}
            tab={
              <span className="flex items-center gap-2 text-base font-medium px-6 py-3 rounded-t-lg">
                <FontAwesomeIcon icon={tab.icon} className="text-xl" />
                {tab.label}
              </span>
            }
          >
            <div className="mt-4 p-4 bg-gray-50 rounded-lg">
              <PurchaseOrderTableComponent status={tab.key} />
            </div>
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default PurchaseOrderGateway;
